'use strict';

function ctrl($scope, $http, $location, $window) {
    let model = this;
    model.user = {};
    model.submitSetPass = false;
    // get reset token on load
    $http.post(api+'/auth/setpass', { key: $location.$$search.key })
    .success(function (token) {
        $window.sessionStorage.token = token; // token is now set to the setPassWordToken
        model.setpass = function (form, user) {
            $http.post(
                api+'/auth/pass/setpass',
                {
                    key: $location.$$search.key,
                    password1: model.user.password1,
                    password2: model.user.password2
                }
            )
            .success(function () {
                // redirect to login
                model.disableSubmit = true;
                $location.url('/login');
            })
            .error(function (error) {
                model.disableSubmit = false;
                model.passworderror = 'Error setting password. ' + error.message;
            });
        };
    })
    .error(function (err) {
        console.log(err);
        // redirect to login
        $location.url('/login');
    });
}

ctrl.$inject = ['$scope', '$http', '$location', '$window'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/auth/controllers/setpass.js
 **/